import { render } from "./ventilationController.vue?vue&type=template&id=79968979&scoped=true"
import script from "./ventilationController.vue?vue&type=script&lang=js"
export * from "./ventilationController.vue?vue&type=script&lang=js"

import "./ventilationController.vue?vue&type=style&index=0&id=79968979&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79968979"]])

export default __exports__